<template>
  <container :class="{ 'is-in-sdk': isInSdk }">
    <div class="work-list">
      <transition name="fade-in">
        <div class="mask" v-if="showLoading">
          <div class="lds-ellipsis" :class="$platformClass">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </transition>
      <transition-group name="fade-in">
        <template v-if="!showLoading">
          <work-card
            @go-detail="goDetail(i)"
            v-for="(item, i) in showList"
            :key="item.SUPPORT_ORDER_ID"
            :work="item"
            :index="i"
          ></work-card>
          <div
            class="work-list-holder"
            key="work-list-holder"
            v-if="!showList.length"
          >
            <p>{{ letters._noYet }}</p>
          </div>
        </template>
      </transition-group>
    </div>
    <Add class="create" @click="goCreate"></Add>
  </container>
</template>
<script>
import container from '../../components/support/Container.vue';
import workCard from '../../components/support/workCard.vue';
import getLetters from '../../mixins/getLetters.js';

import { mapActions, mapState } from 'vuex';
import { OPEN_PAGE_NAME } from '../../store/support/event-type';
import globalConfig from '../../utiles/globalConfig.js';
import bridge from '@utiles/bridge';

export default {
  name: 'my-work-list',
  mixins: [getLetters],
  data() {
    return {
      showLoading: false,
      isInSdk: bridge.runInsdk()
    };
  },
  beforeCreate() {
    globalConfig.storeEntryParams();
  },
  // created: function () {
  //   this.showLoading = true;
  //   let query = this.$route.query;
  //   this.getWorkList().then(
  //     function (res) {
  //       if (res.result === 1 && !res.data.length) {
  //         this.$store.commit(OPEN_PAGE_NAME, "creatework");
  //         this.$router.replace({ name: "creatework", query });
  //       }
  //       this.showLoading = false;
  //     }.bind(this)
  //   );
  // },
  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler(to, from) {
        if (to.name !== 'mylist') {
          return;
        }
        this.showLoading = true;
        let query = this.$route.query;
        this.getWorkList().then(
          function (res) {
            if (res.result === 1 && !res.data?.LIST?.length) {
              this.$store.commit(OPEN_PAGE_NAME, 'creatework');
              this.$router.replace({ name: 'creatework', query });
            }
            this.showLoading = false;
          }.bind(this)
        );
      }
    }
  },
  computed: {
    ...mapState({
      workList: state => state.support.workList
    }),
    showList() {
      let list = this.workList && JSON.parse(JSON.stringify(this.workList));
      // 工单仅按时间排序，不管是否处理(2020.08.03需求)
      let arr =
        list &&
        list.length &&
        list.sort((a, b) => b.CREATE_TIME - a.CREATE_TIME);
      return arr;
    }
  },
  methods: {
    ...mapActions(['getWorkList']),
    goCreate: function () {
      let query = this.$route.query;
      this.$router.push({ name: 'creatework', query });
    },
    goDetail: function (index) {
      let workId = this.showList[index].SUPPORT_ORDER_ID;
      let query = this.$route.query;
      this.$router.push({ name: 'mywork', params: { workId }, query });
    }
  },
  components: {
    workCard,
    container
  }
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/support.scss';
@import '../../assets/scss/platform-support.scss';
.work-list {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  &-holder {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    p {
      width: fit-content;
      font-size: 36px;
      color: #707070;
      text-align: center;
    }
  }
}
.create {
  @include size(107, 107);
  display: inline-block;
  @include bgPng('cross-icon');
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 9;
}
.mask {
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: transparent;
  .lds-ellipsis {
    display: inline-block;
    position: relative;
    width: 160px;
    height: 160px;
    position: absolute;
    top: 40%;
    left: 50%;
    margin-top: -80px;
    margin-left: -80px;
  }
  .lds-ellipsis div {
    position: absolute;
    top: 66px;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background: #57ae67;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }
  .lds-ellipsis div:nth-child(1) {
    left: 16px;
    animation: lds-ellipsis1 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(2) {
    left: 16px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(3) {
    left: 64px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(4) {
    left: 112px;
    animation: lds-ellipsis3 0.6s infinite;
  }
  @keyframes lds-ellipsis1 {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }
  @keyframes lds-ellipsis3 {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
  }
  @keyframes lds-ellipsis2 {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(48px, 0);
    }
  }
}

.is-in-sdk {
  $safeBottomDis: 60px;
  .work-list {
    box-sizing: border-box;
    padding-bottom: $safeBottomDis;
  }
  .create {
    bottom: 30px + $safeBottomDis;
  }
}
</style>
